export const ActividadCiudadanoEstadoMixin = {
  methods: {
    estadoTag(code) {
      switch (code) {
        case 2:
        case 12:
        case 7:
        case 9:
        case 17:
          return 'success'
        case 3:
        case 5:
        case 10:
        case 13:
        case 18:
          return 'danger'
        case 6:
        case 8:
        case 14:
          return 'warning'
        case 4:
          return 'info'
        case 1:
        case 11:
        case 16:
      }
      return 'primary'
    },
  }
}
